export default __webpack_public_path__ + "static/media/choose-mode-text.adf46837.svg";